import provideDataHook from '~/helpers/provideDataHook';
import { objectsFilterDataHook } from '../objectsFilterDataHook';
import { RedirectHandler } from '../RedirectHandler';

export default provideDataHook(
  'FilterPage-LightTransport',
  objectsFilterDataHook({ mainCategories: ['light_transport'] }),
  { skipSpinner: true }
)(RedirectHandler);
